<template>
   <div class="" id="tags_section">
      <info-box :title="'Tags'">

         <div id="tags-wrapper" class="widget">

            <!-- <div id="tag-btn-wrapper">
               <button class="btn-add block-box-label" title="Add a tag" @click="toggleShowInput(), $emit('addTagClicked')">
						Add Tags
               </button>
               <span id="addTag" v-if="showInput">
                  <input type="text" id="tagValue" v-model="tags" />
               </span> 
            </div>
				<div id="tags-list">
					<div class="tags">{{tags}}</div>
				</div> -->

            <input-tags v-model="tags">
               <div class="tags-input"
                  slot-scope="{tag,removeTag,inputEventHandlers,inputBindings}">
                  <input
                  class="tags-input-text" placeholder="Add tags"
                  v-on="inputEventHandlers"
                  v-bind="inputBindings"
                  >
                  <span v-for="tag in tags"
                  class="tags-input-tag">
                     <span class="tag">{{ tag }}</span>
                     <button type="button" class="tags-input-remove"
                        v-on:click="removeTag(tag)"
                     >&times;
                     </button>
                  </span>
               </div>
            </input-tags>
         </div>
      </info-box>

   </div>
</template>

<script>

export default {
	props: {
      recid: Number | String,
      saved: Boolean
   },

	data: function() {
		return {
			showInput: false, 
			tags: [],
		}
   },
   
   created() {
      this.getTags();
   },

	methods: {
      toggleShowInput: function(){
         this.showInput = !this.showInput;
      },
		updateTag(value) {
         this.$parent.$emit('TagUpdate', value);
      },
      getTags() {
         let self = this;
         $.post(
            this.BARD_HOST + '/media/tags/' + this.recid,
            {
               'token'      : localStorage.getItem('token'),
            }, function(data) {
               if (!data.error) {
                  for (let t of data) {
                     self.tags.push(t);
                  }
               } else {
                  // self.handleFailedAPICall('/media/tags/' + self.recid, 'ProgramBlockDisplayTags', data);
               }
            }
         ).fail(function(e) {
            console.log("Error with /media/tags/" + e.responseText);
         });
      }
   },

   watch: {

      recid() {
         this.tags = [];
         this.getTags();
      }
   }
}
</script>

<style lang="scss" scoped>
#tags_section {
   margin-bottom: 10px;
}

#tags-wrapper {

   .tags-input {	
      background-color: transparent;
      transition: background-image 0.25s ease; 

      .tags-input-text {
         outline: 0;
         margin-bottom: .25rem;
         padding-left: 25px;
         text-transform: uppercase;
         font-size: .9375rem;
         padding-top: .25rem;
         padding-bottom: .25rem;
         border: 0; 
         width: 90%;
         height: 50px; 

         background: url('../../../../assets/img/instances/SVGs/bttn_add.svg') 
            no-repeat 
            left center 
            transparent;
         background-size: 18px 18px;

         &:hover,
         &:focus,
         &:active {
            cursor: pointer;
            color: white;
            background-image: url('../../../../assets/img/instances/SVGs/bttn_add-active.svg'); 
         }

         &::placeholder {
            color: #a4a4a4;
            font-size: .75rem;
            text-transform: uppercase;
         }
      }
   }

	.tags-input-tag {
      display: inline-block;
      margin-right: .25rem;
      margin-bottom: .25rem;
      border-radius: 4px;
      background-color: #2c405a;

		.tag {
         display: inline-block;
			background-color: transparent;
			color: #0093ee;
      }
      
      button {
         background: transparent;
         border: 0;
         color: #0093ee;
      }
	}
}
</style>